
import React from "react";
import { Clock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { VerifyPayments } from "@/components/VerifyPayments";

export function AdminTools() {
  return (
    <div className="mt-8 bg-white p-6 rounded-xl shadow-md border border-gray-100">
      <div className="flex items-center gap-3 mb-6">
        <Clock className="h-6 w-6 text-amber-500" />
        <h2 className="text-2xl font-bold">Ferramentas Administrativas</h2>
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <VerifyPayments />
        <Card className="overflow-hidden border-none shadow-md">
          <div className="h-2 bg-amber-50 w-full"></div>
          <div className="p-6">
            <h3 className="font-semibold text-xl mb-2">Estatísticas do Sistema</h3>
            <p className="text-gray-500">Visualize estatísticas gerais do sistema (em breve)</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
